import { inject, Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { ApolloQueryResult } from '@apollo/client/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataRequest } from '@tiltgroup/web-components';
import { Query, QueryTeamsArgs, TeamPaginator } from '@graphql-types';
import { QueriesBaseService } from '@services/queries/queries-base.service';
import { teamsQuery } from '@services/queries/queries/teams.queries';

@Injectable({
  providedIn: 'root',
})
export class TeamsQueriesService extends QueriesBaseService {
  private _apollo = inject(Apollo);

  getTeams(request: DataRequest<QueryTeamsArgs>): Observable<TeamPaginator> {
    const { page, size, where, sort } = request;

    return this._apollo
      .query({
        query: teamsQuery,
        variables: {
          page,
          size,
          where,
          ...(sort && { orderBy: this.orderBy(sort) }),
        },
      })
      .pipe(map((res: ApolloQueryResult<Query>) => res?.data?.teams));
  }
}
